import React from 'react';

const PersonalInterests = () => {
  return (
    <section className="personal-interests">
      <h2>Personal Interests</h2>
      <p>Cooking / Running / Films / Trying out new restaurants / Pop Culture Gossip</p>
    </section>
  );
};

export default PersonalInterests;

